import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'
/**
 * @implements Service
 */
export class GetNavigationLinksSearchService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.localStorageRepository
   */
  constructor({config, localStorageRepository}) {
    super()

    this._config = config
    this._repository = localStorageRepository
  }

  /**
   * @return {Promise<Object, Error>} NavigationLinksValueObject
   */
  @inlineError
  async execute(navigationLinksRequestValueObject) {
    return this._repository
      .getNavigationLinks(navigationLinksRequestValueObject)
      .then(([navigationLinksError, navigationLinksResponse]) => {
        if (navigationLinksError) return Promise.reject(navigationLinksError)
        return navigationLinksResponse
      })
  }
}
